import { FETCH_SHIPMENT_LIST_LOADING, FETCH_SHIPMENT_LIST_DONE, FETCH_SHIPMENT_LIST_ERROR,
  FETCH_SHIPMENT_DETAIL_LOADING, FETCH_SHIPMENT_DETAIL_DONE, FETCH_SHIPMENT_DETAIL_ERROR,
  FETCH_SHIPMENT_HISTORY_LOADING, FETCH_SHIPMENT_HISTORY_DONE, FETCH_SHIPMENT_HISTORY_ERROR,
  FETCH_SHIPMENT_DOCUMENT_LOADING, FETCH_SHIPMENT_DOCUMENT_DONE, FETCH_SHIPMENT_DOCUMENT_ERROR,
  DOWNLOAD_SHIPMENT_DOCUMENT_LOADING, DOWNLOAD_SHIPMENT_DOCUMENT_DONE, DONWLOAD_SHIPMENT_DOCUMENT_ERROR,
  UPLOAD_SHIPMENT_DOCUMENT_LOADING, UPLOAD_SHIPMENT_DOCUMENT_DONE, UPLOAD_SHIPMENT_DOCUMENT_ERROR,
  FETCH_SHIPMENT_PRICE_LOADING, FETCH_SHIPMENT_PRICE_DONE, FETCH_SHIPMENT_PRICE_ERROR,
  DOWNLOAD_SHIPMENT_INVOICE_LOADING, DOWNLOAD_SHIPMENT_INVOICE_DONE, DOWNLOAD_SHIPMENT_INVOICE_ERROR,
  FETCH_SHIPMENT_INVOICE_LOADING, FETCH_SHIPMENT_INVOICE_DONE, FETCH_SHIPMENT_INVOICE_ERROR,
  POST_SHIPMENT_REQUEST_LOADING, POST_SHIPMENT_REQUEST_DONE, POST_SHIPMENT_REQUEST_ERROR,
  FETCH_OTIF_LOADING, FETCH_OTIF_DONE, FETCH_OTIF_ERROR,
  // leadtime mutation
  GET_LEADTIME_LOADING,
  GET_LEADTIME_DONE,
  GET_LEADTIME_ERROR,
  // UPDATE DETAIL MUTATION
  UPDATE_SHIPMENT_DETAILS_LOADING,
  UPDATE_SHIPMENT_DETAILS_DONE,
  UPDATE_SHIPMENT_DETAILS_ERROR,
  // DOWNLOAD PRICE DETAIL
  DOWNLOAD_PRICE_DETAIL_LOADING,
  DOWNLOAD_PRICE_DETAIL_DONE,
  DOWNLOAD_PRICE_DETAIL_ERROR,
  // GET ACTIVE USER
  FETCH_ACTIVE_USER_LOADING,
  FETCH_ACTIVE_USER_DONE,
  FETCH_ACTIVE_USER_ERROR,
  // GET PENDING USER
  FETCH_PENDING_USER_LOADING,
  FETCH_PENDING_USER_DONE,
  FETCH_PENDING_USER_ERROR,

  GET_DELAY_LOG_LOADING,
  GET_DELAY_LOG_DONE,
  GET_DELAY_LOG_ERROR,
  // filter shipment
  FILTER_SHIPMENT_LOADING,
  FILTER_SHIPMENT_DONE,
  FILTER_SHIPMENT_ERROR,

  DOWNLOAD_EFBL_LOADING,
  DOWNLOAD_EFBL_DONE,
  DOWNLOAD_EFBL_ERROR

} from './actions'

export default {
  [FETCH_SHIPMENT_LIST_LOADING] (state) {
    state.isLoading = true
    state.error = false
  },

  [FETCH_SHIPMENT_LIST_DONE] (state, items) {
    state.items = items
    state.isLoading = false
    state.error = false
  },

  [FETCH_SHIPMENT_LIST_ERROR] (state, error) {
    state.error = error
    state.isLoading = false
  },

  [FILTER_SHIPMENT_LOADING] (state) {
    state.isLoadingGetFilterShipment = true
  },
  [FILTER_SHIPMENT_DONE] (state, items) {
    state.getFilterShipment = items
    state.isLoadingGetFilterShipment = false
  },
  [FILTER_SHIPMENT_ERROR] (state, error) {
    state.errorGetFilterShipment = error
    state.isLoadingGetFilterShipment = false
  },

  [FETCH_OTIF_LOADING] (state) {
    state.otifIsLoading = true
    state.errorOtif = false
  },

  [FETCH_OTIF_DONE] (state, otif) {
    state.otif = otif
    state.otifIsLoading = false
    state.errorOtif = false
  },

  [FETCH_OTIF_ERROR] (state, error) {
    state.errorOtif = error
    state.otifIsLoading = false
  },

  [FETCH_SHIPMENT_DETAIL_LOADING] (state) {
    state.item = {}
    state.isLoading = true
    state.error = false
  },

  [FETCH_SHIPMENT_DETAIL_DONE] (state, items) {
    state.item = items
    state.isLoading = false
    state.error = false
  },

  [FETCH_SHIPMENT_DETAIL_ERROR] (state, error) {
    state.item = {}
    state.error = error
    state.isLoading = false
  },

  [FETCH_SHIPMENT_HISTORY_LOADING] (state) {
    state.isLoadingHistory = true
  },

  [FETCH_SHIPMENT_HISTORY_DONE] (state, items) {
    state.history = items
    state.isLoadingHistory = false
  },

  [FETCH_SHIPMENT_HISTORY_ERROR] (state, error) {
    state.errorHistory = error
    state.isLoadingHistory = false
  },

  [FETCH_SHIPMENT_DOCUMENT_LOADING] (state) {
    state.isLoadingDoc = true
    state.errorDoc = false
  },

  [FETCH_SHIPMENT_DOCUMENT_DONE] (state, items) {
    state.docs = items
    state.isLoadingDoc = false
    state.errorDoc = false
  },

  [FETCH_SHIPMENT_DOCUMENT_ERROR] (state, error) {
    state.errorDoc = error
    state.isLoadingDoc = false
  },

  [DOWNLOAD_SHIPMENT_DOCUMENT_LOADING] (state) {
    state.isDownloading = true
    state.errorDownloading = false
  },

  [DOWNLOAD_SHIPMENT_DOCUMENT_DONE] (state) {
    state.isDownloading = false
    state.errorDownloading = false
  },

  [DONWLOAD_SHIPMENT_DOCUMENT_ERROR] (state) {
    state.errorDownloading = true
    state.isDownloading = false
  },

  [UPLOAD_SHIPMENT_DOCUMENT_LOADING] (state) {
    state.isUploading = true
    state.errorUploading = false
  },

  [UPLOAD_SHIPMENT_DOCUMENT_DONE] (state) {
    state.isUploaded = true
    state.isUploading = false
    state.errorUploading = false
  },

  [UPLOAD_SHIPMENT_DOCUMENT_ERROR] (state) {
    state.errorUploading = true
    state.isUploading = false
  },

  [FETCH_SHIPMENT_PRICE_LOADING] (state) {
    state.prices = []
    state.isLoadingPrice = true
    state.errorPrice = false
  },

  [FETCH_SHIPMENT_PRICE_DONE] (state, items) {
    state.prices = items
    state.isLoadingPrice = false
    state.errorPrice = false
  },

  [FETCH_SHIPMENT_PRICE_ERROR] (state, error) {
    state.prices = []
    state.errorPrice = true
    state.isLoadingPrice = false
  },

  [DOWNLOAD_SHIPMENT_INVOICE_LOADING] (state) {
    state.isDownloading = true
    state.errorDownloading = false
  },

  [DOWNLOAD_SHIPMENT_INVOICE_DONE] (state) {
    state.isDownloading = false
    state.errorDownloading = false
  },

  [DOWNLOAD_SHIPMENT_INVOICE_ERROR] (state) {
    state.errorDownloading = true
    state.isDownloading = false
  },

  [FETCH_SHIPMENT_INVOICE_LOADING] (state) {
    state.isLoadingInvoice = true
    state.errorInvoice = false
  },

  [FETCH_SHIPMENT_INVOICE_DONE] (state, items) {
    state.invoices = items
    state.isLoadingInvoice = false
    state.errorInvoice = false
  },

  [FETCH_SHIPMENT_INVOICE_ERROR] (state, error) {
    state.errorInvoice = error
    state.isLoadingInvoice = false
  },

  [POST_SHIPMENT_REQUEST_LOADING] (state) {
    state.isPostingReq = true
    state.isSuccessfulReq = false
    state.erroReq = false
  },

  [POST_SHIPMENT_REQUEST_DONE] (state, items) {
    state.isPostingReq = false
    state.isSuccessfulReq = true
    state.erroReq = false
  },

  [POST_SHIPMENT_REQUEST_ERROR] (state, error) {
    state.isPostingReq = false
    state.isSuccessfulReq = false
    state.erroReq = true
  },

  [GET_LEADTIME_LOADING] (state) {
    state.isLeadTimeLoading = true
    state.isLeadtimeError = false
  },

  [GET_LEADTIME_DONE] (state, items) {
    state.leadTimeItem = items
    state.isLeadTimeLoading = false
    state.isLeadtimeError = false
  },

  [GET_LEADTIME_ERROR] (state, error) {
    state.isLeadTimeLoading = false
    state.isLeadtimeError = error
  },

  [UPDATE_SHIPMENT_DETAILS_LOADING] (state) {
    state.isUpdating = true
    state.isUpdated = {}
  },

  [UPDATE_SHIPMENT_DETAILS_DONE] (state, isUpdated) {
    state.isUpdating = false
    state.isUpdated = isUpdated
  },

  [UPDATE_SHIPMENT_DETAILS_ERROR] (state, error) {
    state.errorUpdate = true
    state.isUpdating = false
    state.isUpdated = {}
  },

  [DOWNLOAD_PRICE_DETAIL_LOADING] (state) {
    state.downloadPriceDetail = {}
    state.isLoadingDownloadPriceDetail = true
  },

  [DOWNLOAD_PRICE_DETAIL_DONE] (state, items) {
    state.downloadPriceDetail = items
    state.isLoadingDownloadPriceDetail = false
  },

  [DOWNLOAD_PRICE_DETAIL_ERROR] (state, error) {
    state.errorDownloadPriceDetail = error
    state.isLoadingDownloadPriceDetail = false
    state.downloadPriceDetail = {}
  },

  [FETCH_ACTIVE_USER_LOADING] (state) {
    state.isLoadingActiveUser = true
  },

  [FETCH_ACTIVE_USER_DONE] (state, items) {
    state.activeUser = items
    state.isLoadingActiveUser = false
  },

  [FETCH_ACTIVE_USER_ERROR] (state, error) {
    state.errorActiveUser = error
    state.isLoadingActiveUser = false
  },

  [FETCH_PENDING_USER_LOADING] (state) {
    state.isLoadingPendingUser = true
  },

  [FETCH_PENDING_USER_DONE] (state, items) {
    state.pendingUser = items
    state.isLoadingPendingUser = false
  },

  [FETCH_PENDING_USER_ERROR] (state, error) {
    state.errorPendingUser = error
    state.isLoadingPendingUser = false
  },

  [GET_DELAY_LOG_LOADING] (state) {
    state.isLoadingGetDelayLog = true
  },
  [GET_DELAY_LOG_DONE] (state, items) {
    state.getDelayLog = items
    state.isLoadingGetDelayLog = false
  },
  [GET_DELAY_LOG_ERROR] (state, error) {
    state.isErrorGetDelayLog = error
    state.isLoadingGetDelayLog = false
  },

  [DOWNLOAD_EFBL_LOADING] (state) {
    state.downloadEfbl = {}
    state.isLoadingDownloadEfbl = true
  },

  [DOWNLOAD_EFBL_DONE] (state, items) {
    state.downloadEfbl = items
    state.isLoadingDownloadEfbl = false
  },

  [DOWNLOAD_EFBL_ERROR] (state, error) {
    state.errorDownloadEfbl = error
    state.isLoadingDownloadEfbl = false
    state.downloadEfbl = {}
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/shipment/mutations.js